import React from "react";
import { ReactSelectField } from "../../components/ReactHooksFormFields/ReactSelectField";
import { InputField } from "../../components/ReactHooksFormFields/inputField";
import { DatePickerField } from "../../components/ReactHooksFormFields/DatePickerField";
import {
  useGetPracticeSpecialitiesQuery,
  useGetPracticeLocationsQuery,
} from "../../redux/service/appointments_service";
import moment from "moment";
const AppointmentLocation = ({ control, errors }) => {
  const { data: specialities } = useGetPracticeSpecialitiesQuery();
  const { data: locations } = useGetPracticeLocationsQuery();

  return (
    <div>
      <div class="grid grid-cols-3 gap-4">
        <div>
          <ReactSelectField
            control={control}
            name="location"
            title="Location"
            optionData={locations}
            showLabel="name"
            menuPlacement="bottom"
            uniqueKey="id"
            errors={errors}
            rules={{ required: { value: true } }}
          />
        </div>
        <div className="">
          <DatePickerField
            control={control}
            name="date"
            title="Date"
            errors={errors}
            defaultValues={new Date()}
            dateFormat={"MM/dd/yyyy"}
            minDate={moment().toDate()}
            rules={{ required: { value: true } }}
          />
        </div>
        <div class="">
          <ReactSelectField
            control={control}
            name="specialty"
            title="Specialty"
            optionData={specialities?.map((item) => ({
              id: item,
              specialty: item,
            }))}
            showLabel="specialty"
            uniqueKey="id"
            errors={errors}
            menuPlacement="bottom"
            rules={{ required: { value: true } }}
          />
        </div>
      </div>
      <div className="mt-4">
        <InputField
          control={control}
          name="reason"
          title="Reason"
          errors={errors}
          rules={{ required: { value: true } }}
          autoComplete="off"
        />
      </div>
    </div>
  );
};
export default AppointmentLocation;
